import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { getCodeColor } from "../components";



export const GeneratePdfInventario = ({ data, themeColor, convertPrice = (() => { }) }) => {
	const themeConverted = getCodeColor(themeColor);

	const styles = StyleSheet.create({
		page: {
			padding: '20px 10px 50px 10px',
			fontFamily: "Helvetica",
			fontSize: 12,
			lineHeight: 1.5,
			position: "relative",
		},
		headerContainer: {
			flexDirection: "row",
			alignContent: "center",
			paddingBottom: 10,
		},
		headerLeft: {
			flexDirection: "column",
			width: "40%",
			lineHeight: 1.2,
			fontSize: 7,
		},
		logo: {
			width: 150,
			height: 100,
		},
		titleBig: {
			fontFamily: "Helvetica-Bold",
			fontSize: 19,
			letterSpacing: 1,
			margin: 0,
			paddingLeft: 35,
			position: "relative",
			top: "15",
			right: "40",
		},
		titleNumber: {
			fontSize: 18,
			color: "#ff3d3d",
			fontWeight: "bold",
			paddingLeft: 70,
			letterSpacing: 2,
			fontFamily: "Helvetica-Bold",
			position: "relative",
			right: 20,
		},
		subHeaderContainer: {
			flexDirection: "row",
			justifyContent: "space-between",
			paddingRight: "10",
			alignItems: "center",
			position: "relative",
			bottom: 5,
			fontSize: 9,
		},
		tableContainer: {
			width: "100%",
			marginVertical: 10,
		},
		tableHeader: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
		},
		tableHeaderCell: {
			padding: 5,
			fontWeight: "bold",
			textAlign: "center",
			fontSize: 8,
			color: "white",
			flex: 1,
		},
		tableRow: {
			flexDirection: "row",
			borderBottomWidth: 1,
			borderBottomColor: "#dddddd",
			borderBottomStyle: "solid",
		},
		// Adding the missing tableCell style
		tableCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
		},
		totalCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
			color: "#fff",
			fontWeight: "bold",
			flex: 1,
		},
		tableRowTotal: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
			fontWeight: "bold",
			flexWrap: "wrap"
		},
		fechaHoy: {
			fontSize: 8,
			position: "relative",
			bottom: 5,
		},
		signatureContainer: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-around",
			marginTop: 30,
		},
		signatureLine: {
			marginBottom: 5,
		},
		signatureBox: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		// Add column-specific styles
		tableCellFecha: { flex: 0.9, padding: '5px 1px' },
		tableCellCodigo: { flex: 0.8, minWidth: 45 },
		tableCellProducto: { flex: 2.5, textAlign: "left" },
		tableCellStock: { flex: 0.5 },
		tableCellPrecioCompra: { flex: 0.7, minWidth: 50 },
		TCPC: { flex: 0.5, minWidth: 50 },
		tableCellBenef: { flex: 0.7, minWidth: 50 },
		tableCellPrecioVenta: { flex: 0.7, minWidth: 50 },
	});

	if (!data || !data.body_table || !Array.isArray(data.body_table)) {
		return (
			<Document>
				<Page size="A4" style={styles.page}>
					<Text>No hay datos para generar el PDF.</Text>
				</Page>
			</Document>
		);
	}

	const rows = data.body_table.map((item) => {
		const precioCompra = parseFloat(item.purchase_price || "0");
		const precioVenta = parseFloat(item.price1 || "0");
		return {
			fecha: item.last_update || "",
			codigo: item.code || "",
			producto: item.name || "",
			stock: item.stock || 0,
			precioCompra,
			benef: precioVenta - precioCompra,
			precioVenta,
		};
	});

	const totalStock = rows.reduce((acc, curr) => acc + curr.stock, 0);
	const totalPrecioCompra = rows.reduce((acc, curr) => acc + curr.precioCompra, 0).toFixed(2);
	const totalPCperStock = rows.reduce((acc, curr) => acc + (parseFloat(curr.precioCompra) * parseInt(curr.stock)), 0);
	const totalBenef = rows.reduce((acc, curr) => acc + curr.benef, 0).toFixed(2);
	const totalPrecioVenta = rows.reduce((acc, curr) => acc + curr.precioVenta, 0).toFixed(2);

	const { info } = data;
	const apiUrl = process.env.REACT_APP_API_URL;

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.headerContainer}>
					<View style={styles.headerLeft}>
						<View style={{ position: "relative" }}>
							<Image source={`${apiUrl}${info.logo}`} src={`${apiUrl}${info.logo}`} style={styles.logo} />
						</View>
						<View>
							<Text>Empresa: {info.cName}</Text>
							<Text>Dirección: {info.address}</Text>
							<View style={{ flexDirection: "row", marginTop: "2px" }}>
								<Text>NIT: {info.cNit}</Text>
								<Text style={{ paddingLeft: 15 }}>Tel: {info.phone}</Text>
							</View>
						</View>
					</View>

					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleBig}>Reporte de Inventario</Text>
					</View>
				</View>

				<View style={{ display: "flex", flexDirection: "row", gap: 5, position: "relative", bottom: 0 }}>
					<Text style={styles.fechaHoy}>Fecha: {data.dt_generated}</Text>
				</View>

				<View style={styles.tableContainer}>
					<View style={styles.tableHeader}>
						<Text style={[styles.tableHeaderCell, styles.tableCellFecha]}>Fecha</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCodigo]}>Código</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellProducto]}>Producto</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellStock]}>Stock</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPrecioCompra]}>P. Compra</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPrecioVenta]}>Costo Total</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellBenef]}>Benef</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPrecioVenta]}>Precio Venta</Text>
					</View>

					{rows.map((item, index) => (
						<View style={styles.tableRow} key={index}>
							<Text style={[styles.tableCell, styles.tableCellFecha]}>{item.fecha}</Text>
							<Text style={[styles.tableCell, styles.tableCellCodigo]}>{item.codigo}</Text>
							<Text style={[styles.tableCell, styles.tableCellProducto]}>{item.producto}</Text>
							<Text style={[styles.tableCell, styles.tableCellStock]}>{item.stock}</Text>
							<Text style={[styles.tableCell, styles.tableCellPrecioCompra]}>{convertPrice(item.precioCompra, null, true)}</Text>
							<Text style={[styles.tableCell, styles.tableCellPrecioCompra]}>
								{convertPrice(parseInt(item.stock) * parseFloat(item.precioCompra), null, true)}
							</Text>
							<Text style={[styles.tableCell, styles.tableCellBenef]}>{convertPrice(item.benef, null, true)}</Text>
							<Text style={[styles.tableCell, styles.tableCellPrecioVenta]}>{convertPrice(item.precioVenta, null, true)}</Text>
						</View>
					))}

					<View style={styles.tableRowTotal}>
						<Text style={[styles.totalCell, styles.tableCellFecha]}></Text>
						<Text style={[styles.totalCell, styles.tableCellCodigo]}></Text>
						<Text style={[styles.totalCell, styles.tableCellProducto, { textAlign: "center" }]}>TOTAL</Text>
						<Text style={[styles.totalCell, styles.tableCellStock]}>{totalStock}</Text>
						<Text style={[styles.totalCell, styles.tableCellPrecioCompra]}>{convertPrice(totalPrecioCompra)}</Text>
						<Text style={[styles.totalCell, styles.tableCellPrecioVenta]}>{convertPrice(totalPCperStock)}</Text>
						<Text style={[styles.totalCell, styles.tableCellBenef]}>{convertPrice(totalBenef)}</Text>
						<Text style={[styles.totalCell, styles.tableCellPrecioVenta]}>{convertPrice(totalPrecioVenta)}</Text>
					</View>
				</View>

				<View style={styles.signatureContainer}>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{data.seller}</Text>
						<Text>Vendedor</Text>
					</View>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{info.manager}</Text>
						<Text>Gerente General</Text>
					</View>
				</View>
			</Page>
		</Document>
	);
};
